<template>
  <v-file-input
    ref="fileInput"
    :value="wrappedItem"
    :label="label"
    dense
    :success="success"
    :loading="uploading"
    @change="onFileChange"
  >
    <template v-slot:selection="{ text }">
      {{ text }}
    </template>
  </v-file-input>
</template>

<script>
  import i18n from '../../i18n'
  export default {
    props: {
      item: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: i18n.t('agreement'),
      },
      url: {
        type: String,
        default: '/admin/file',
      },
    },
    data: function () {
      return {
        uploading: false,
        success: false,
        wrappedItem: null,
        lastItem: null,
      }
    },
    watch: {
      item: function () {
        this.wrappedItem = new File([''], this.item)
      },
    },
    created: function () {
      this.wrappedItem = new File([''], this.item)
    },
    methods: {
      onFileChange (file) {
        if (!file) { return }

        if (this.lastItem && this.lastItem.name === this.item.name && this.lastItem.lastModified === this.item.lastModified && this.lastItem.size === this.item.size && this.lastItem.type === this.item.type) { return }

        const data = new FormData()
        this.uploading = true
        this.success = false
        this.lastItem = this.item

        data.append('file', file)

        this.$post(this.url, data)
          .then((res) => {
            this.$toast('File uploaded')

            this.$emit('update', res.data)
            this.uploading = false
            this.success = true
          })
          .catch((err) => {
            this.uploading = false
            this.success = false
            this.$refs.fileInput.reset()
            this.$emit('update', this.item)
            this.wrappedItem = new File([''], this.item)
          })
      },
    },
  }
</script>
